<template>

    <v-hero class="pb-0" fluid>

        <div class="container">
            <div class="row d-flex justify-content-center">
                <div class="col col-md-8">
                    <a href="https://stripe.com/partners/crowdpower" target="_blank">
                        <img class="svp" src="/img/svp.svg" title="Stripe Verified Partner" width="160" height="auto" />
                    </a>
                    <h1 class="mt-15 mb-20">{{ $t('title') }}</h1>
                    <h2 class="mb-30">{{ $t('subtitle') }}</h2>
                    <v-signup class="mb-15" />
                    <v-claims class="mb-30" />
                </div>
            </div>
            <div class="row d-flex justify-content-center">
                <div class="col col-md-10">
                    <div class="ss">
                        <img class="ss-image" src="/img/home-feature1.png" width="100%" height="auto" />
                    </div>
                </div>
            </div>
        </div>

        <img class="bg" src="/img/bg.svg" />

    </v-hero>

</template>

<style scoped lang="scss">

    .container {
        position: relative;
        z-index: 1;
    }

    .bg {
        bottom: 0;
        height: auto;
        left: 0;
        position: absolute;
        width: 100%;
        z-index: 0;
    }

    .svp {
        border: 1px solid $color-text;
        border-radius: 5px;
        overflow: hidden;
    }

    .ss {
        display: grid;
        place-items: center;
        position: relative;
        z-index: 1;
        .ss-play {
            background: rgba(0,0,0,0.1);
            border: 1px solid $color-rule;
            border-radius: 50px;
            display: grid;
            height: 100px;
            place-items: center;
            position: absolute;
            transition: background-color .3s;
            width: 100px;
            z-index: 1;
            &::after {
                content: "";
                margin-left: 8px;
                width: 0;
                height: 0;
                border-top: 16px solid transparent;
                border-left: 26px solid $color-text;
                border-bottom: 16px solid transparent;
            }
            &:hover {
                background: rgba(0,0,0,0.2);
            }
        }
        .ss-image {
            position: relative;
            z-index: 0;
        }
    }

</style>

<script>

export default {

    data() {
        return {
            appUrl: process.env.VUE_APP_APP_URL,
        }
    },

}

</script>